module.exports = __webpack_public_path__ + "sunsemweb/img/abanner.8c77c4ae.png";